import { Switch, Route, Router } from 'react-router-dom';
import SwitchRoutes from 'Routes/switchRoutes';
import { history } from 'Helpers/history';
import Login from 'Container/LoginContainer';
import ForgotPassword from 'Container/ForgotPasswordContainer';
import { connect } from 'react-redux';
import { profileActions } from 'Actions';
import ResetPassword from 'Container/ResetPassword';
import Activateaccount from 'Container/Activateaccount';
import Successful from 'Components/ResetPassword/Successful';
import ErrorBoundary from 'Components/ErrorBoundary';
import routesPath from 'Constants/routes.constants';
import PageNotFound from 'Components/PageNotFound';
import { decryptUserToken } from './Helpers';
import { ToastContainer } from 'react-toastify';

const openUrls = [ '/forgotPassword', '/resetpassword', 'activateaccount' ];

function fetchProfileInitial(props, pathname) {
  if (openUrls.indexOf(pathname) === -1 && decryptUserToken()) {
    props.fetchProfile();
  }
}

function App(props) {
  return (
    <div className="App">
      <ToastContainer 
        position="top-right"
        autoClose={ 3000 }
        hideProgressBar={ false }
        newestOnTop={ false }
        closeOnClick={ false }
        rtl={ false }
        pauseOnFocusLoss={ false }
        draggable={ false }
        pauseOnHover={ false }
        limit={ 1 }
      />
      <Router history={ history }>
        <ErrorBoundary>
          {fetchProfileInitial(props, history.location.pathname)}
          <Switch>
            <Route path="/forgotPassword" component={ ForgotPassword } />
             <Route path="/resetpassword" component={ ResetPassword } />
            <Route path="/activateaccount" component={ Activateaccount } />
            <Route path="/login" component={ Login } />
            <Route
							exact
							path={ routesPath.pageNotFound }
							component={ PageNotFound }
						/>
						<SwitchRoutes />
						<Route component={ PageNotFound } />
          </Switch>
        </ErrorBoundary>
      </Router>
    </div>
  );
}

const mapDispatchToProps = {
  fetchProfile: profileActions.fetchProfile,
};

export default connect(null, mapDispatchToProps)(App);
